import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../contexts/MapContext';

import * as S from './style';

const Loading = observer(() => {
  const { getIsLoading, setIsLoading, setOpenModal } = useStore();
  const [showRetry, setShowRetry] = useState(false);

  setTimeout(() => {
    if (getIsLoading() === true) setShowRetry(true);
  }, 6000);

  const handleRetryClick = () => {
    setOpenModal(true);
    setIsLoading(false);
  };
  return (
    <S.Container>
      <span role='img' aria-label='emoji'>
        🕵️
      </span>
      <div>현재 위치와 마스크 정보를 가져오고 있습니다...</div>
      <div>GPS가 부정확하다면 주소검색을 이용해보세요</div>
      <br />
      <div>내 위치 확인에 꼭꼭 동의해주세요!</div>
      <div>{showRetry}</div>
      <br />
      <br />
      {showRetry && (
        <>
          <S.Retry onClick={handleRetryClick}>다시 시도해보기!</S.Retry>
          <S.GPS>
            너무 느리다구요?
            <br />
            혹시 '내 위치 확인'이
            <br />
            차단되어있지는 않은지 확인 해주세요 👆
          </S.GPS>
        </>
      )}
    </S.Container>
  );
});

export default Loading;
